import Vue from 'vue';
import _ from 'lodash';

export default Vue.component('login', {
  template: require('./template.html'),
  name: 'login',
  data() {
    return {
      border: '#2d2e33',
      forgotPass: false,
      loginError: false,
      loading: false,
      showResetCode: false,
      resetcode: '',
      email: '',
      username: '',
      password: '',
      showPassword: false,
      showNewPassword: false,
      confirmpassword: '',
      confirmUser: false,
      needsMFA: false,
      mfacode: '',
      rememberMe: false,
      firstTime: false,
      showHintGroup: false,
      passFormatError: false,
      hint: {
        lc: false,
        uc: false,
        num: false,
        len: false,
        sym: false,
      },
      loaders: {
        Facebook: false,
        Google: false,
      },
    };
  },
  created() {
    this.rememberMe = JSON.parse(window.localStorage.getItem('rememberMe'));
    const user = JSON.parse(window.localStorage.getItem('userCreds'));
    if (this.rememberMe && user) {
      this.username = user.username;
      this.password = user.password;
    }
  },
  mounted() {
    this.drawGoogleFont();
    this.setUpLoginListeners();
  },
  methods: {
    authenticate() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.loading = true;
          this.loginError = false;
          const payload = {
            username: this.username,
            password: this.password,
          };
          try {
            const userExists = await this._cognitoLogin(payload);
            if (userExists) {
              // save or remove user creds in local storage if user
              // chooses one
              let username = this.username;
              let password = this.password;
              if (!this.rememberMe) {
                username = '';
                password = '';
              }
              window.localStorage.setItem('userCreds', JSON.stringify({
                username,
                password,
              }));
              if (this.firstTime) {
                await this.$store.dispatch('setFirstLogin', true);
                this.firstTime = false;
              }
              this.$log.info('Logged in user: ', userExists);
              // route back to splash to grab all the users data
              this.$router.push({ path: '/splash' });
            }
          } catch (e) {
            const message = e.message || e;
            this.loginError = message;
            if (e.code === 'UserNotConfirmedException') {
              this.loginError = false;
              this.confirmUser = true;
              this.forgotPass = false;
              this.showResetCode = false;
            }
            if (message === 'SMS_MFA') {
              this.loginError = false;
              this.needsMFA = true;
            }
          } finally {
            this.loading = false;
          }
        }
      });
    },
    submitMFAcode() {
      this.$validator.validate('mfacode', this.mfacode).then(async (result) => {
        if (result) {
          this.loading = true;
          this.loginError = false;
          try {
            await this._loginSendMFAcode({ code: this.mfacode });
            this.needsMFA = false;
            this.$router.push({ path: '/splash' });
          } catch (e) {
            // warn user this email does not exist in our customer db
            this.$log.error('error: ', e);
            this.loginError = e.message;
          } finally {
            this.loading = false;
          }
        }
      });
    },
    sendCode() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          try {
            this.loading = true;
            this.loginError = false;
            this.showResetCode = false;
            const payload = {
              email: this.email,
            };
            await this._cognitoForgotPassword(payload);
            this.showResetCode = true;
          } catch (e) {
            // warn user this email does not exist in our customer db
            this.$log.error('error: ', e);
            this.loginError = `Oops! Looks like there was an error: ${e.message}`;
          } finally {
            this.loading = false;
          }
        }
      });
    },
    resetPass() {
      const { lc, uc, num, len, sym } = this.hint;
      if (!lc || !uc || !num || !len || !sym) {
        this.passFormatError = true;
        return;
      }
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.loading = true;
          this.loginError = false;
          const payload = {
            email: this.email,
            code: this.resetcode,
            password: this.password,
          };
          try {
            await this._cognitoSubmitResetPass(payload);
            // after password is reset, reauthenticate them by logging in
            const p = {
              username: this.email,
              password: this.password,
            };
            const userExists = await this._cognitoLogin(p);
            this.$log.info('Logged in user: ', userExists);
            // route back to splash to grab all the users data
            this.$router.push({ path: '/splash' });
          } catch (e) {
            this.$log.error('error: ', e);
            this.loginError = e.message || e;
          } finally {
            this.loading = false;
          }
        }
      });
    },
    showHint() {
      if (!this.showHintGroup) {
        this.showHintGroup = true;
      }
      this.passFormatError = false;
      const lc = /^(?=.*[a-z]).+$/;
      const uc = /^(?=.*[A-Z]).+$/; // uppercase letter
      const num = /^(?=.*\d).+$/; // a number
      const sym = /^(?=.*[!@#$%^&*_-]).+$/; // symbol
      const len = /^.{7,}.+$/; // at least 8 chars
      // check lowercase letter
      this.hint.lc = lc.test(this.password);
      // check uppercase letter
      this.hint.uc = uc.test(this.password);
      // check for a number
      this.hint.num = num.test(this.password);
      // check for symbol
      this.hint.sym = sym.test(this.password);
      // check password length
      this.hint.len = len.test(this.password);
    },
    async confirmNewUser() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.loading = true;
          try {
            const payload = {
              email: this.username,
              code: this.resetcode,
              password: this.password,
            };
            await this._cognitoConfirmNewUser(payload);
            // try logging user in
            await this._cognitoLogin({
              username: this.username,
              password: this.password,
            });

            await this.$store.dispatch('setFirstLogin', true);
            // check if rememberMe was checked
            if (this.rememberMe) {
              window.localStorage.setItem('userCreds', JSON.stringify({
                username: this.username,
                password: this.password,
              }));
            }
            this.$router.push({ path: '/splash' });
          } catch (e) {
            this.$log.error('error: ', e);
            this.loginError = e.message || e;
            // if there is a credentials error, we need to show login again
            // to retry
            if (e.code === 'NotAuthorizedException') {
              this.confirmUser = false;
              this.firstTime = true;
            }
            // if user tries to login for the first time after
            // the 24 hour code expiration, we send a new code
            if (e.code === 'ExpiredCodeException') {
              this.loginError = 'That code is no longer valid. We have sent a new one. Please try again with the new code.';
              await this._cognitoResendNewUserCode({ email: this.username });
            }
          } finally {
            this.loading = false;
          }
        }
      });
    },
    async launchSocialAuth(provider) {
      const isLoading = _.find(this.loaders, ldr => ldr);
      if (!isLoading) {
        this.loaders[provider] = true;
        try {
          // this will launch the cognito social hosted UI redirect,
          // show the user the social middleman and redirect back after
          // successful authentication. with this method we do not need
          // to include social libraries as we set that in aws / cognito UI
          await this._cognitoSocialSignIn(provider);
        } catch (e) {
          this.$log.error(e.message || e);
          this.loaders[provider] = false;
        }
        // as this action will always redirect the user, we don't stop the loader
        // only on error
      }
    },
    setUpLoginListeners() {
      this.$amplify.Hub.listen('auth', ({ payload: { event } }) => {
        // any time there is a redirect from the cognito hosted UI we need
        // to send back to splash to grab the user from the user pool as it
        // does not register right away. This will only happen when a user
        // proceeds with a social provider and is redirected.
        if (event === 'signIn') {
          this.$log.debug('hosted ui redirect');
          this.$router.push({ path: '/splash' });
        }
      });
    },
    drawGoogleFont() {
      // why load Roboto? Well due to Google's guidelines on using
      // their sign in buttons, they require this font. See URL
      // https://developers.google.com/identity/branding-guidelines#font
      const parent = this.$refs.loginPage;
      const exists = parent.querySelectorAll('#google-login-font')[0];
      if (!exists) {
        const style = document.createElement('style');
        style.setAttribute('href', 'https://fonts.googleapis.com/css?family=Roboto&display=swap');
        style.setAttribute('rel', 'stylesheet');
        style.id = 'google-login-font';
        parent.insertBefore(style, parent.firstChild);
      }
    },
    rememberMeCheck() {
      window.localStorage.setItem('rememberMe', this.rememberMe);
    },
    resetLocals() {
      this.forgotPass = false;
      this.showResetCode = false;
      this.needsMFA = false;
      this.loginError = false;
    },
    formatErrors(ers) {
      return ers.join(' ');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/login/index.js